const log = (err) => {
  if (`${process.env.LOG}`) {
    if (err?.stack && err?.message) {
      console.error(err);
    } else {
      console.info(err);
    }
  }
};

module.exports = {
  log,
};
